<app-nav></app-nav>
<!--Scroll to top button-->
<button id="scrollbtn" (click)="scrollToTop()" class="scrolltotop" [ngClass]="{'scrolltotopanimation': scrollTop}" ></button>
<router-outlet></router-outlet>
<app-footer></app-footer>
